import Constant from '@/const'
import Store from '@/store/index.js'
export default {
  namespaced: true,
  actions: {
    /** 登録可能な文字か判定する */
    validMoji({ commit, dispatch }, data) {
      const request = {
        url: `${Constant.API_URL.VALID_MOJI}`,
        params: data,
      }
      return dispatch('http/post', { ...request }, { root: true }).then(
        (v) => v.data
      )
    },

    /** ロギングする */
    logging({ commit, dispatch }, data) {
      const request = {
        url: `${Constant.API_URL.LOGGING}`,
        params: data,
      }
      return dispatch('http/post', { ...request }, { root: true })
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/util.js